// ABOUTME: Resolves an image content value into a displayable URI.
// ABOUTME: External links are used as-is, media ids are resolved through the media endpoint.

export const isExternalImageUrl = (value: string) => /^https?:\/\//i.test(value);

export const resolveImageUri = (value: string) =>
    isExternalImageUrl(value) ? value : `${import.meta.env.VITE_API_BASE_URI}/media/${value}`;

/**
 * A small preview of an image content value. The server falls back to the original whenever the
 * media is not a raster image or has no thumbnail yet, so this is always safe for an `<img src>`.
 * External URLs pass through untouched, exactly as `resolveImageUri` does.
 *
 * A second helper rather than a parameter on `resolveImageUri`: either default would be a footgun,
 * two names are greppable, and `resolveImageUri` keeps its exact meaning so a call site that was
 * never migrated is merely "as today", never a broken download.
 */
export const resolveImageThumbnailUri = (value: string) =>
    isExternalImageUrl(value)
        ? value
        : `${import.meta.env.VITE_API_BASE_URI}/media/${value}/thumbnail`;
